import { styled } from '@mui/material';

export const Thumb = styled('div')`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
`;

export const ImageWrapper = styled('div')`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const RemoveCircle = styled('div')`
  display: flex;
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  top: -7px;
  right: -10px;
  z-index: 100;
  justify-content: center;
  align-items: center;
`;

export const SpinnerW = styled('div')`
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 10px;
  margin-right: 16px;
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.palette.info.p030};
  position: relative;
`;

export const SpinnerBackdrop = styled('span')`
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: not-allowed;
`;

export const PreviewImage = styled('img')`
  max-width: 80vw;
  max-height: 80vh;
  object-fit: cover;
  display: block;
`;
